import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Badge } from '@repo/ui/primitives/Badge';
import { MaskIcon } from '@repo/ui/primitives/MaskIcon';
export const BestFor = t0 => {
  const $ = _c(7);
  const {
    bestFor,
    ourPickFor,
    isRewardsOrSubprimeRU: t1
  } = t0;
  const isRewardsOrSubprimeRU = t1 === undefined ? false : t1;
  const t2 = isRewardsOrSubprimeRU ? "flex-start" : undefined;
  let t3;
  if ($[0] !== t2) {
    t3 = <MaskIcon data-testid="checkmark-icon" glyph="verified" size="md" css={{
      backgroundColor: "primary.dark",
      alignSelf: t2
    }} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = bestFor ? `Best for: ${bestFor}` : ourPickFor ? `Our pick for: ${ourPickFor}` : undefined;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: {
        base: "[100%]",
        _pcMd: "auto"
      }
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      as: "h2",
      css: css.raw({
        textAlign: "left",
        my: "0",
        _pcMd: {
          textAlign: "center"
        }
      })
    };
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t3 || $[5] !== t4) {
    t7 = <Badge iconNode={t3} text={t4} css={t5} typographyProps={t6} />;
    $[4] = t3;
    $[5] = t4;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
};